export default "__VITE_ASSET__DBC8P9dq__"